import { Link } from "react-router-dom";
import type { NewsItem } from "@/types";

interface NewsCardProps {
  item: NewsItem;
  layout?: "vertical" | "horizontal";
}

export default function NewsCard({ item, layout = "vertical" }: NewsCardProps) {
  if (layout === "horizontal") {
    return (
      <Link
        to={`/news/${item.id}`}
        className="group flex gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300 md:p-4"
      >
        <div className="h-20 w-28 shrink-0 overflow-hidden rounded-md bg-background-200 md:h-24 md:w-36">
          <img
            src={item.cover}
            alt={`${item.title} 配图`}
            title={`${item.title} - 漫蛙2动漫资讯`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="min-w-0 flex-1">
          <span className="text-xs font-medium text-primary-600">{item.category}</span>
          <h3 className="mt-1 line-clamp-2 text-sm font-semibold text-foreground-950 transition-colors group-hover:text-primary-700 md:text-base">
            {item.title}
          </h3>
          <p className="mt-1.5 line-clamp-2 hidden text-xs text-foreground-600 sm:block">{item.summary}</p>
          <span className="mt-2 block text-xs text-foreground-400">{item.date}</span>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/news/${item.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
    >
      <div className="h-44 w-full overflow-hidden bg-background-200 md:h-48">
        <img
          src={item.cover}
          alt={`${item.title} 配图`}
          title={`${item.title} - 漫蛙2动漫资讯`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="flex flex-1 flex-col p-4 md:p-5">
        <div className="flex items-center gap-3 text-xs text-foreground-500">
          <span className="rounded-full bg-accent-100 px-2.5 py-1 font-medium text-accent-800">{item.category}</span>
          <span>{item.date}</span>
        </div>
        <h3 className="mt-3 line-clamp-2 text-base font-semibold text-foreground-950 transition-colors group-hover:text-primary-700">
          {item.title}
        </h3>
        <p className="mt-2 line-clamp-3 flex-1 text-sm leading-relaxed text-foreground-600">{item.summary}</p>
        <span className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-primary-600">
          阅读全文
          <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5"></i>
        </span>
      </div>
    </Link>
  );
}